import HudlFull from 'marketing-website/components/icons/HudlFull';
import heroImage from 'marketing-website/media/images/pages/case-studies/buzzfeed/cover@2x.jpg';
import statsImage from 'marketing-website/media/images/pages/case-studies/hudl/stats@2x.jpg';
import image00a from 'marketing-website/media/images/pages/case-studies/hudl/image-00-a@2x.jpg';
import image00b from 'marketing-website/media/images/pages/case-studies/hudl/image-00-b@2x.jpg';
import image01a from 'marketing-website/media/images/pages/case-studies/hudl/image-01-a@2x.jpg';
import image01b from 'marketing-website/media/images/pages/case-studies/hudl/image-01-b@2x.jpg';
import image02 from 'marketing-website/media/images/pages/case-studies/hudl/image-02@2x.jpg';
import image03a from 'marketing-website/media/images/pages/case-studies/hudl/image-03-a@2x.jpg';
import image03b from 'marketing-website/media/images/pages/case-studies/hudl/image-03-b@2x.jpg';
import quote from 'marketing-website/media/images/pages/case-studies/hudl/quote@2x.jpg';

const hudlAssets = {
  heroImage: {
    src: heroImage,
    srcSet: heroImage,
    alt: '',
  },
  heroLogo: HudlFull,
  statsImage: {
    src: statsImage,
    srcSet: statsImage,
    maxWidth: 1290,
    alt: '',
  },
  stats: [
    {
      id: 0,
      stat: '2x',
      title: 'Prototyping speed',
      copy:
        'Hudl found that their designers created prototypes twice as fast with Marvel',
    },
    {
      id: 1,
      stat: '160+',
      title: 'Screens in a project',
      copy:
        'Marvel enables Hudl’s high fidelity, large scale prototypes which reach 160 screens',
    },
    {
      id: 2,
      stat: '16',
      title: 'Concurrent projects',
      copy:
        'Hudl work on 16+ projects at a time and Marvel gives them a stable, solid platform to do so ',
    },
  ],
  doubleImages: {
    zero: [
      {
        src: image00a,
        maxWidth: 460,
        alt: '',
      },
      {
        src: image00b,
        maxWidth: 460,
        alt: '',
      },
    ],
    first: [
      {
        src: image01a,
        maxWidth: 536,
        alt: '',
      },
      {
        src: image01b,
        maxWidth: 550,
        alt: '',
      },
    ],
    second: [
      {
        src: image03a,
        maxWidth: 556,
        alt: '',
      },
      {
        src: image03b,
        maxWidth: 556,
        alt: '',
      },
    ],
    third: [
      {
        src: quote,
        maxWidth: 556,
        alt: '',
      },
      {
        maxWidth: 520,
        copy:
          '"We don’t release anything without some kind of testing. Every morning in our Slack channel we get an automatic update for our research department with scheduled research events. We test daily."',
      },
    ],
  },
  singleImages: {
    first: {
      src: image02,
      maxWidth: 1141,
      alt: '',
    },
  },
};

export default hudlAssets;



// WEBPACK FOOTER //
// ./src/configs/caseStudies/hudl.js